import { CompensationMethodData } from "@redotech/redo-customer-portal-shared/flow/util";
import { ExchangeVariant } from "@redotech/redo-model/draft-return/draft-return-items";
import { Step } from "@redotech/redo-model/return-flow";
import { ReturnOptionMethod } from "@redotech/redo-model/return-flow/return-option";
import { memo, useEffect } from "react";

export const SubmitWarranty = memo(function SubmitWarranty({
  submitItem,
  sameItemVariant,
  flowStep,
}: {
  submitItem: (data: CompensationMethodData) => void;
  sameItemVariant: ExchangeVariant | null;
  flowStep: Step.SubmitWarranty;
}) {
  useEffect(() => {
    if (
      flowStep.option.method.type === ReturnOptionMethod.EXCHANGE &&
      sameItemVariant
    ) {
      submitItem({
        variantExchangeItem: {
          variantId: sameItemVariant.id,
          preserveProperties: true,
          image: sameItemVariant.image,
          title: sameItemVariant.title,
        },
      });
    } else {
      submitItem({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <div />;
});
